import { FunctionComponent, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { PermissionCheck } from "@/components";
import { PermissionRoles } from "@/enum";
import { Tabs, TabPanel } from "@/components/Tabs/Tabs";

import { FeatureManagementTable } from "./components/FeatureManagementTable";
import { OnboardingTriggerTab } from "./components/OnboardingTriggerTab";

enum FeatureManagementTab {
	FEATURE_FLAGS = "FEATURE_FLAGS",
	ONBOARDING_TRIGGERS = "ONBOARDING_TRIGGERS",
}

const tabs = [
	{ label: "Feature Flags", value: FeatureManagementTab.FEATURE_FLAGS },
	{ label: "Onboarding Triggers", value: FeatureManagementTab.ONBOARDING_TRIGGERS },
];

export const FeatureManagement: FunctionComponent = () => {
	const [searchParams, setSearchParams] = useSearchParams();

	const [currentTab, setCurrentTab] = useState<FeatureManagementTab>(
		(searchParams.get("tab") as FeatureManagementTab) || FeatureManagementTab.FEATURE_FLAGS
	);

	const handleTabChange = (value: string) => {
		const tab = value as FeatureManagementTab;

		setCurrentTab(tab);
		setSearchParams({ tab }, { replace: true });
	};

	return (
		<PermissionCheck redirect={true} requiredPermissions={[PermissionRoles.GLOBAL_ADMIN]}>
			<div className="w-full">
				<h1 className="mb-6 text-2xl font-semibold">Feature Management</h1>
				<Tabs
					activeTab={currentTab}
					ariaLabel="Feature Management tabs"
					tabs={tabs}
					onTabChange={handleTabChange}
				/>
				<div className="mt-6">
					<TabPanel activeTab={currentTab} value={FeatureManagementTab.FEATURE_FLAGS}>
						<FeatureManagementTable />
					</TabPanel>
					<TabPanel activeTab={currentTab} value={FeatureManagementTab.ONBOARDING_TRIGGERS}>
						<OnboardingTriggerTab />
					</TabPanel>
				</div>
			</div>
		</PermissionCheck>
	);
};
